class StoreName extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.parentElement.childNodes.forEach((node) => {
      if (node.nodeName === "#text") {
        this.parentElement.removeChild(node);
      }
    });

    this.parentElement.classList.add("store-name-wrapper");

    let data;
    try {
      const source = this.querySelector("script");
      if (!source) return;

      data = JSON.parse(source.innerHTML);
    } catch (error) {
      console.warn("Error generating store name", error);
      return;
    }

    const { name, image, type, associatedStoreName } = data;

    const imageEl = image
      ? `<img src="${image}" class="store-name__image">`
      : "";
    const associatedStoreNameEl = associatedStoreName
      ? `<div class="store-name__associated-store">${associatedStoreName}</div>`
      : "";

    this.innerHTML = `
      <div class="store-name ${image ? "" : "store-name--no-image"}">
        ${imageEl}
        <div class="store-name__content">
          <div class="store-name__name">${name}</div>
          <div class="store-name__type">${type}</div>
          ${associatedStoreNameEl}
        </div>
      </div>
    `;
  }

  disconnectedCallback() {
    this.parentElement.classList.remove("store-name-wrapper");
  }
}

if (!customElements.get("store-name")) {
  customElements.define("store-name", StoreName);
}
